module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_Luftmangel.1aecbd0a.svg";